import React, { useEffect, useRef, useState } from 'react'

import pauseIcon from "../../../../assets/icons/pause.png";
import playIcon from "../../../../assets/icons/play.png";
import playlistIcon from "../../../../assets/icons/playlist.png";
import { ReactComponent as RepeatOnceIcon } from "../../../../assets/icons/repeat-once.svg";
import { ContBtn, ImgIcon, MainBtnsWrapper, MainContBtn, PlayerBtnsWrapper, PlayerWrapper, PlayImgIcon, Timeline } from './styles';
import ReplayBtn from '../../../../components/buttons/replayBtn';
import audioFile from "../../../../assets/audio/audio.ogg"
import { useAudioSpeed, useFlashcard, useLoopOnce, usePlaylist } from '../../../../zustand/handlers';
import { SpinLoading } from 'antd-mobile';
import { BASE_URL } from '../../../../constants/link';

function AudioPlayer({ name, audio: audioPath, index }) {
  const audioRef = useRef();
  const playlist = usePlaylist();
  const loop = useLoopOnce();
  const speed = useAudioSpeed();
  const flashcard = useFlashcard();
  const [playing, setPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isReady, setIsReady] = useState(false);
  // const audio = new Audio(audioFile);

  const togglePlayPause = () => {
    if (playing) {
      audioRef.current?.pause();
      setPlaying(false);
    } else {
      audioRef.current?.play();
      setPlaying(true);
    }
  };
  const replayAudio = () => {
    const audio = audioRef.current;
    if (audio) {
      audio.currentTime = 0; // Reset to the start
      audio.play();           // Play the audio again
    }
  };

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.playbackRate = speed.value;
    }
  }, [speed.value, audioRef.current])

  // useEffect(() => {

  //   // Add event listeners using addEventListener
  //   const handlePlay = () => setStatus('playing');
  //   const handlePause = () => setStatus('paused');
  //   const handleEnded = () => setStatus('ended');
  //   const handleTimeUpdate = () => setCurrentTime(audio.currentTime);
  //   const handleError = (e) => console.error('Error occurred: ', e);
  //   const handleLoadedMetadata = () => {
  //     setDuration(audio.duration);
  //     console.log('Audio loaded, duration:', audio.duration);
  //   };

  //   audio.addEventListener('play', handlePlay);
  //   audio.addEventListener('pause', handlePause);
  //   audio.addEventListener('ended', handleEnded);
  //   audio.addEventListener('timeupdate', handleTimeUpdate);
  //   audio.addEventListener('error', handleError);
  //   audio.addEventListener('loadedmetadata', handleLoadedMetadata);

  //   return () => {
  //     // Cleanup event listeners on unmount
  //     audio.removeEventListener('play', handlePlay);
  //     audio.removeEventListener('pause', handlePause);
  //     audio.removeEventListener('ended', handleEnded);
  //     audio.removeEventListener('timeupdate', handleTimeUpdate);
  //     audio.removeEventListener('error', handleError);
  //     audio.removeEventListener('loadedmetadata', handleLoadedMetadata);
  //   };
  // }, []);



  return (
    <PlayerWrapper>
      {/* <div>
        {String(audio.paused)}
      </div>
      <div>
        {String(audio.ended)}
      </div> */}
      {/* <div>
        ready: {String(isReady)}
      </div>
      <div>
        currentTime: {String(currentTime)}
      </div>
      <div>
        duration: {String(duration)}
      </div>
      <div>
        audioPath: {audioPath}
      </div> */}
      {/* <div>
        {String(audio.volume)}
      </div>
      <div>
        {String(audio.playbackRate)}
      </div> */}
      {/* <audio preload="metadata">
        <source src={audioFile} />
      </audio> */}
      {flashcard.current === index &&
        <audio loop={loop.active} autoPlay
          // controls 
          ref={audioRef} preload="metadata"
          onDurationChange={(e) => setDuration(e.currentTarget.duration)}
          onCanPlay={(e) => {
            setIsReady(true);
          }}
          onPlaying={() => setPlaying(true)}
          onPause={() => setPlaying(false)}
          onTimeUpdate={(e) => {
            setCurrentTime(e.currentTarget.currentTime);
            // handleBufferProgress(e);
          }}
        >
          <source type="audio/mpeg" src={`${BASE_URL}/${audioPath}`} />
        </audio>}
      {/* <div>Percentage: {(currentTime / audio.duration) * 100}</div> */}
      <Timeline name={name} percentage={(currentTime / duration) * 100} />
      <PlayerBtnsWrapper>
        <ContBtn onClick={playlist.activate}>
          <ImgIcon src={playlistIcon} alt="playlist" />
        </ContBtn>
        <MainBtnsWrapper>
          <ReplayBtn onClick={replayAudio} />
          <MainContBtn
            disabled={!isReady && playing}
            name={name} size='large' shape="rounded" onClick={() => {
              togglePlayPause();
            }}>
            {
              !isReady && playing ?
                <SpinLoading /> :
                playing ?
                  <ImgIcon src={pauseIcon} alt="pause" /> :
                  <PlayImgIcon src={playIcon} alt='play' />
            }
          </MainContBtn>
          <ContBtn onClick={loop.toggle}>
            {/* <ImgIcon src={repeatIcon} alt="play" /> */}
            <RepeatOnceIcon
              style={{
                fill: loop.active ? `var(--border-${name})` : "black"
              }}
            />
          </ContBtn>
        </MainBtnsWrapper>
        <ContBtn onClick={speed.activate}>
          {speed.value}x
        </ContBtn>
      </PlayerBtnsWrapper>
    </PlayerWrapper>
  )
}

export default AudioPlayer